import { type ReactNode, useEffect, useState } from 'react';

import { RouterProvider } from 'react-router-dom';

import createLegacyRouter from 'legacyRouter';
import Layout from 'nextComponents/layout';
import createStore from 'store';

import { setUserCountry } from 'dux/user/actions';

const store = createStore();

type AppProps = {
  userGeolocationGuessedCountry: string;
};

export default function App({ userGeolocationGuessedCountry }: AppProps) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    // ensure to be fetching on the first state that gets rendered
    // store.dispatch(fetchAuthIfNeeded()); // This will trigger feature flag fetch via middleware
    // Storing the user guessed country to make it accessible to all pages
    if (isMounted) {
      store.dispatch(setUserCountry(userGeolocationGuessedCountry));
    }
  }, [isMounted]);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return <RouterProvider router={createLegacyRouter()} />;
}

App.getLayout = (page: ReactNode) => <Layout>{page}</Layout>;
